/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2 12H22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 8V7.5V7.5C22 4.46243 19.5376 2 16.5 2V2H16M22 16V16.5V16.5C22 19.5376 19.5376 22 16.5 22V22H16M2 16V16.5V16.5C2 19.5376 4.46243 22 7.5 22V22H8M2 8V7.5V7.5C2 4.46243 4.46243 2 7.5 2V2H8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="6"
				fill="currentColor"
			/>
			<path
				d="M22 8V7.5V7.5C22 4.46243 19.5376 2 16.5 2V2H16M22 16V16.5V16.5C22 19.5376 19.5376 22 16.5 22V22H16M2 16V16.5V16.5C2 19.5376 4.46243 22 7.5 22V22H8M2 8V7.5V7.5C2 4.46243 4.46243 2 7.5 2V2H8M2 12H22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M22 8V7.5V7.5C22 4.46243 19.5376 2 16.5 2V2H16M22 16V16.5V16.5C22 19.5376 19.5376 22 16.5 22V22H16M2 16V16.5V16.5C2 19.5376 4.46243 22 7.5 22V22H8M2 8V7.5V7.5C2 4.46243 4.46243 2 7.5 2V2H8M2 12H22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 8V7.5V7.5C22 4.46243 19.5376 2 16.5 2V2H16M22 16V16.5V16.5C22 19.5376 19.5376 22 16.5 22V22H16M2 16V16.5V16.5C2 19.5376 4.46243 22 7.5 22V22H8M2 8V7.5V7.5C2 4.46243 4.46243 2 7.5 2V2H8M11.0001 12H22M2 12H7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M22 8V7.5V7.5C22 4.46243 19.5376 2 16.5 2V2H16M22 16V16.5V16.5C22 19.5376 19.5376 22 16.5 22V22H16M2 16V16.5V16.5C2 19.5376 4.46243 22 7.5 22V22H8M2 8V7.5V7.5C2 4.46243 4.46243 2 7.5 2V2H8M2 12H22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M22 8V7.5V7.5C22 4.46243 19.5376 2 16.5 2V2H16M22 16V16.5V16.5C22 19.5376 19.5376 22 16.5 22V22H16M2 16V16.5V16.5C2 19.5376 4.46243 22 7.5 22V22H8M2 8V7.5V7.5C2 4.46243 4.46243 2 7.5 2V2H8M2 12H22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
